import React from "react";
import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";


function NotFound(props) {
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title="404"
      subTitle="متاسفانه صفحه مورد نظر پیدا نشد."
      extra={
        <Button type="primary" onClick={() => navigate(-1)}>
          بازگشت
        </Button>
      }
    />
  );
}

export default NotFound;
